(() => {
  function bindGalleryArrows(root = document) {
    const galleries = root.querySelectorAll('media-gallery');
    galleries.forEach((gallery) => {
      if (gallery.dataset.ttGalleryNavBound === 'true') return;

      const viewer = gallery.querySelector('[id^="GalleryViewer"]');
      const slider = viewer?.querySelector('[id^="Slider-Gallery"]');
      const controls = viewer?.querySelector('.slider-buttons');
      const prevButton = controls?.querySelector('.slider-button--prev');
      const nextButton = controls?.querySelector('.slider-button--next');
      const currentNode = controls?.querySelector('.slider-counter--current');
      const totalNode = controls?.querySelector('.slider-counter--total');

      if (!viewer || !slider || !prevButton || !nextButton) return;

      gallery.dataset.ttGalleryNavBound = 'true';

      // Dawn's SliderComponent also writes to this counter using visible-width math.
      // For the Turbo-style gallery, we own navigation/count state in this script.
      const disableDawnCounter = () => {
        viewer.currentPageElement = null;
        viewer.pageTotalElement = null;
      };
      disableDawnCounter();
      window.requestAnimationFrame(disableDawnCounter);
      if (window.customElements?.whenDefined) {
        window.customElements.whenDefined('slider-component').then(disableDawnCounter);
      }

      const getSlides = () => Array.from(slider.querySelectorAll('[id^="Slide-"]'));

      const activeIndex = (slides) => {
        let closest = 0;
        let delta = Number.POSITIVE_INFINITY;
        const scrollLeft = slider.scrollLeft;

        slides.forEach((slide, index) => {
          const diff = Math.abs(slide.offsetLeft - scrollLeft);
          if (diff < delta) {
            delta = diff;
            closest = index;
          }
        });

        const byClass = slides.findIndex((slide) => slide.classList.contains('is-active'));
        if (byClass >= 0) {
          const classDelta = Math.abs(slides[byClass].offsetLeft - scrollLeft);
          // Keep class-based state only when it matches the current scroll position.
          if (classDelta <= 2) return byClass;
        }

        return closest;
      };

      const updateState = () => {
        const slides = getSlides();
        if (!slides.length) return;

        const index = activeIndex(slides);
        const last = slides.length - 1;

        prevButton.toggleAttribute('disabled', index <= 0);
        nextButton.toggleAttribute('disabled', index >= last);

        if (currentNode) currentNode.textContent = String(Math.max(index + 1, 1));
        if (totalNode) totalNode.textContent = String(Math.max(slides.length, 1));
      };

      const go = (direction) => {
        const slides = getSlides();
        if (slides.length < 2) return;

        const index = activeIndex(slides);
        const targetIndex = Math.max(0, Math.min(index + direction, slides.length - 1));
        const target = slides[targetIndex];
        if (!target) return;

        slides.forEach((slide) => slide.classList.remove('is-active'));
        target.classList.add('is-active');
        slider.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });

        if (typeof gallery.playActiveMedia === 'function') {
          gallery.playActiveMedia(target);
        }

        window.requestAnimationFrame(updateState);
      };

      prevButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
        go(-1);
      }, true);

      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
        go(1);
      }, true);

      slider.addEventListener(
        'scroll',
        () => {
          window.requestAnimationFrame(updateState);
        },
        { passive: true }
      );

      window.addEventListener('resize', updateState);
      updateState();
    });
  }

  document.addEventListener('DOMContentLoaded', () => bindGalleryArrows(document));
  document.addEventListener('shopify:section:load', (event) => bindGalleryArrows(event.target));
})();
